/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	text
} from "svelte/internal";
import { gameStatus } from "src/store.js"

function add_css() {
	var style = element("style");
	style.id = 'svelte-1ovynke-style';
	style.textContent = "button.svelte-1ovynke{flex:1}";
	append(document.head, style);
}

function create_fragment(ctx) {
	var button, t_value = ctx.$gameStatus ? 'Pause' : 'Play' + "", t, button_title_value, dispose;

	return {
		c() {
			button = element("button");
			t = text(t_value);
			attr(button, "title", button_title_value = ctx.$gameStatus ? PAUSE_ALT_TEXT : CONTINUE_ALT_TEXT);
			attr(button, "class", "svelte-1ovynke");
			dispose = listen(button, "click", ctx.toggleGameStatus);
		},

		m(target, anchor) {
			insert(target, button, anchor);
			append(button, t);
		},

		p(changed, ctx) {
			if ((changed.$gameStatus) && t_value !== (t_value = ctx.$gameStatus ? 'Pause' : 'Play' + "")) {
				set_data(t, t_value);
			}

			if ((changed.$gameStatus) && button_title_value !== (button_title_value = ctx.$gameStatus ? PAUSE_ALT_TEXT : CONTINUE_ALT_TEXT)) {
				attr(button, "title", button_title_value);
			}
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(button);
			}

			dispose();
		}
	};
}

const PAUSE_ALT_TEXT = 'Pause game'

const CONTINUE_ALT_TEXT = 'Continue game'

function instance($$self, $$props, $$invalidate) {
	let $gameStatus;

	component_subscribe($$self, gameStatus, $$value => { $gameStatus = $$value; $$invalidate('$gameStatus', $gameStatus); });

	

  function toggleGameStatus () {
    gameStatus.set($gameStatus ? 0 : 1)
  }

	return { toggleGameStatus, $gameStatus };
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1ovynke-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Component;